import { forwardRef } from "react";
import { ModalSheet } from "@/components/modal/sheet/default";
import { cx } from "@/lib/style/cva.config";

export const ModalSheetAutoHeight = forwardRef<
  HTMLIonModalElement,
  React.ComponentProps<typeof ModalSheet>
>((props, ref) => (
  <ModalSheet
    ref={ref}
    className={cx("ion-h-auto", props.className)}
    initialBreakpoint={1}
    breakpoints={[0, 1]}
    {...props}
  />
));

ModalSheetAutoHeight.displayName = "ModalSheetAutoHeight";
